export const TYPES = {
  aggregations: 'aggregations',
}

export const enum FILTER_FIELD {
  type = 'type',
  ownership = 'ownership',
  titulars = 'titulars',
  nature = 'nature',
}

export const enum FILTER_OPERATOR {
  includes = 'includes',
  equals = 'equals',
  excludes = 'excludes',
}

export const enum FILTER_VALUES {
  negative = 'Flux inconnu (négatif)',
}

export interface BudgetFilter {
  field: FILTER_FIELD
  operator: FILTER_OPERATOR
  value: (FILTER_VALUES | string | boolean)[] // TODO: weird type
}

export const AGGREGATE_ID = {
  sumOfAssetsByNature: 'sum of assets by nature',
  monthlySavingsCapacities: 'monthly savings_capacities',
  monthlyLoanCapacities: 'monthly loan_capacities',
}

export const SEGMENT_ID = {
  asset: 'asset',
  liability: 'liability',
}

export type SegmentIdType = ValueOf<typeof SEGMENT_ID>

export const SEGMENT_FIELD = {
  nature: 'nature',
  type: 'type',
  category: 'category',
  shownCategory: 'shown_category',
}

export const SEGMENT_RANGE = {
  monthly: 'monthly',
}

export const REDUCER_FUNCTION = {
  sum: 'sum',
  savingsCapacity: 'savings_capacity',
  loanCapacity: 'loan_capacity',
}

export type ReducerFunctions = ValueOf<typeof REDUCER_FUNCTION>

export const REDUCER_FIELD = {
  amount: 'amount',
  yearlyTaxableIncome: 'yearly_taxable_income',
}

export const AGGREGATION_SCOPE = {
  household: 'household',
  common: 'common',
  person: 'person',
}

export const RECORD_TYPES = {
  asset: 'asset',
  liability: 'liability',
  // TODO: maybe not used
  expense: 'expense',
} as const

export type BudgetRecordTypes = ValueOf<typeof RECORD_TYPES> | ''
